import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import CustomisedButton from '../../components/button/button';
import CustomisedCardBullet from '../../components/card/cardBullet';
import CustomisedErrorCard from '../../components/card/errorCard';
import { IShellConfig } from '../../models/IShellConfig';
import { IGetKycVideoHintsResponse } from '../../models/kyc.model';
import { changeRouteType, getpervInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';
import { RootState } from '../../redux/store';
import { getVideoText } from '../../redux/video/videoSlice';
import { GetKycVideoHints } from '../../services/kyc.service';
import { IVideoAuthorization } from './IVideoAuthorization';
import VideoHintsSkeleton from './videoHintsSkeleton';



const VideoError = ({ setState, referenceKey, rejectReasons }: IVideoAuthorization) => {
    const [jsonFile, setJsonFile] = useState<IShellConfig>();
    const [hints, setHints] = useState<IGetKycVideoHintsResponse>();
    const mode = useSelector((state: RootState) => state.theme) as 'light' | 'dark';
    const dispatch = useDispatch();


    // get app config
    useEffect(() => {
        dispatch(setHeaderTitle({ header: ' خطای احراز هویت ویدیوئی', color: 'var(--header-color)', parentRoute: 'kyc' }));
        fetch('/setting/shellConfig.json')
            .then((response) => response.json())
            .then((data) => {
                setJsonFile(data);
            });


        GetKycVideoHintsMutate({
            referenceKey: referenceKey!
        });
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + Math.random() }));
    }, []);

    const themeColors = jsonFile?.[mode];
    // get hints from api
    const { mutate: GetKycVideoHintsMutate, isLoading } = useMutation(
        GetKycVideoHints,
        {
            onSuccess: (data: IGetKycVideoHintsResponse) => {
                if (data) {
                    setHints(data);
                    dispatch(getVideoText(data.textContent));
                }
            },

            onError: () => { },
        }
    );


    const handleContinue = () => {
        dispatch(changeRouteType({ routeType: 'child' }));
        setState!('captureVideo');
    }
    if (isLoading) {
        return <VideoHintsSkeleton />;
    }
    return (
        <Grid
            container
            flexDirection={'column'}
            sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '100%',
                marginY: '20px',
            }}
            className="container-height-without-drawer"
        >
            <Grid
                item
                sx={{
                    width: '100%',
                }}
            >
                <Grid container flexDirection={'column'} alignItems={'center'}>
                    <Grid item>
                        <Typography
                            sx={{
                                color: `${themeColors?.primaryColorLight900}`,
                                fontWeight: 'bold',
                                fontSize: '.9rem',
                                textAlign: 'center',

                                marginBottom: '10px',
                            }}
                        >
                            پس از بررسی "دلایل خطای احراز هویت ویدئویی"، دکمه
                            <br />
                            "بارگزاری مجدد" را بزنید و با توجه به راهنما زیر مجددا امتحان کنید.
                        </Typography>
                        <Grid item>
                            <CustomisedErrorCard titleList={rejectReasons!} />
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container>
                            {hints?.hints?.map((hint, index: number) => (
                                <Grid item sx={{ width: '100%' }}>
                                    <CustomisedCardBullet
                                        firstTitle={hint}
                                        key={index}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box className="button-container">
                <CustomisedButton
                    title="بارگذاری مجدد"
                    disable={false}
                    onClick={handleContinue}
                    type="button"
                />
            </Box>
        </Grid>
    );
};

export default VideoError;
